import { render, staticRenderFns } from "./BaseComponent.vue?vue&type=template&id=3adb3c72&"
import script from "./BaseComponent.vue?vue&type=script&lang=ts&"
export * from "./BaseComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports